import React from "react";
import { TableContainer, TableHead, TableBody, TableRow, TableCell } from "@mui/material";

import { StyledTable } from "./styles";
import { ShareWithLegalEntitySIDTO } from "../../../../../../models/share-with-legal-entity-si";
import { AddEditSharedWithUser } from "./AddEditSharedWithUser/AddEditSharedWithUser";
import { CompanyLegalEntityRef } from "../../../../../../models/company-accounts/company-legal-entities";
import { LegalEntitySIDTO } from "../../../../../../models/legal-entity-si";
import ActionsWrapper from "./ActionsWrapper/ActionsWrapper";

interface Props {
  items: ShareWithLegalEntitySIDTO[];
  handleUpdate: (action: "add" | "edit" | "remove", item: ShareWithLegalEntitySIDTO) => void;
  defaultLegalEntity: CompanyLegalEntityRef | null;
  legalEntitySI: LegalEntitySIDTO;
  readOnly: boolean;
}

const SharedWithTable = ({ items, handleUpdate, defaultLegalEntity, legalEntitySI, readOnly }: Props) => {
  return (
    <>
      <TableContainer sx={{ width: "100%", height: "50vh", overflow: "auto" }}>
        <StyledTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">User to share</TableCell>

              <TableCell align="center">User who shared</TableCell>

              <TableCell align="center">Last modified by</TableCell>

              <>
                {!readOnly && (
                  <TableCell
                    align="center"
                    sx={{ width: "100px" }}
                  >
                    <AddEditSharedWithUser
                      effect={"add"}
                      handleNotifyParent={(item: ShareWithLegalEntitySIDTO) => handleUpdate("add", item)}
                      defaultLegalEntity={defaultLegalEntity}
                      legalEntitySI={legalEntitySI}
                    />
                  </TableCell>
                )}
              </>
            </TableRow>
          </TableHead>

          <TableBody>
            {!!items.length &&
              items
                .filter((item) => !item.isDeleted)
                .map((item) => {
                  return (
                    <React.Fragment key={item.id}>
                      <TableRow>
                        <TableCell>{item?.user?.name ?? ""}</TableCell>

                        <TableCell>{item?.createdByUser?.name ?? ""}</TableCell>

                        <TableCell>{item?.modifiedByUser?.name ?? ""}</TableCell>

                        <>
                          {!readOnly && (
                            <TableCell align="center">
                              <ActionsWrapper
                                item={item}
                                handleUpdate={handleUpdate}
                                defaultLegalEntity={defaultLegalEntity}
                                legalEntitySI={legalEntitySI}
                              />
                            </TableCell>
                          )}
                        </>
                      </TableRow>
                    </React.Fragment>
                  );
                })}

            {!items.length && (
              <TableRow>
                <TableCell
                  colSpan={readOnly ? 3 : 4}
                  align="center"
                >
                  No items
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </>
  );
};

export default SharedWithTable;
